import React, { useEffect, useState } from "react";
import { Country, State } from "country-state-city";
import { Form } from "react-bootstrap";

const LocationSelector = ({ business, onChange }) => {
  const [countries] = useState(Country.getAllCountries());
  const [states, setStates] = useState([]);

  // Cargar provincias/estados cuando cambia el país
  useEffect(() => {
    const countryCode = business.country || "AR"; // default AR
    if (countryCode) {
      const s = State.getStatesOfCountry(countryCode);
      setStates(s);

      // Si la provincia actual no pertenece al país seleccionado, se limpia
      if (business.state && !s.find(st => st.isoCode === business.state)) {
        onChange("state", "");
        onChange("city", "");
      }
    }
  }, [business.country]); // eslint-disable-line react-hooks/exhaustive-deps

  const selectedCountry = business.country || "AR";

  return (
    <>
      {/* País */}
      <Form.Group className="mb-3">
        <Form.Label>País</Form.Label>
        <Form.Select
          value={selectedCountry}
          onChange={(e) => onChange("country", e.target.value)}
        >
          {countries.map((c) => (
            <option key={c.isoCode} value={c.isoCode}>
              {c.name}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      {/* Provincia */}
      <Form.Group className="mb-3">
        <Form.Label>Provincia / Estado</Form.Label>
        <Form.Select
          value={business.state || ""}
          onChange={(e) => onChange("state", e.target.value)}
        >
          <option value="">Seleccionar provincia</option>
          {states.map((st) => (
            <option key={st.isoCode} value={st.isoCode}>
              {st.name}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      {/* Ciudad - texto libre */}
      <Form.Group className="mb-3">
        <Form.Label>Ciudad</Form.Label>
        <Form.Control
          type="text"
          placeholder="Ej: Mar del Plata"
          value={business.city || ""}
          onChange={(e) => onChange("city", e.target.value)}
        />
        <Form.Text className="text-muted">
          Escribí la ciudad manualmente.
        </Form.Text>
      </Form.Group>
    </>
  );
};

export default LocationSelector;
